











import { Component } from 'vue-property-decorator'

import Field from './Field.vue'

@Component
export default class FieldNumber extends Field {
  get currentValue() {
    const intVal = parseInt(this.field.value, 10)
    const intDropVal = parseInt(this.field.dropoffValue, 10)

    // API : We need to convert INT to STRING
    return this.isSecond ? (this.field.dropoff ? intDropVal.toString() : intVal.toString()) : intVal.toString()
  }
}
